
<script>
	import listBase from '@_system/components/base/list.vue'
	import audit from './audit/index.vue'
	export default {
		extends: listBase,
		name: 'invoiceinputIndex',
		props: {

		},
		data() {
			return {
				loading: false,
				auditShow: true,
				moduleName: 'invoiceinput',
				windowName: '发票进项',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			del(row) {
				this.$confirm('是否删除 ' + row.salername, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api[this.moduleName].delete(row.id).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})
			},
			audit(row) {
				if (row.num > 0) {
					import('./audit/index.vue').then((res) => {
						this.formModule = {
							component: res.default,
							show: true,
							extra: {
								title: '进项审核（' + row.code + '）',
								row: row
							}
						}
					})
				} else {
					this.$message.error('暂无可审核数量')
				}
			},
			auditSubmit() {

			},
			// importtemplate(){
			// 	this.$store.commit('getTemplate','invoiceinput')
			// },
			auditall(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择进项')
				}else{
					let ids = []
					data.forEach((item)=>{
						ids.push(item.id)
					})
					import('./audit/index.vue').then((res) => {
						this.formModule = {
							component: res.default,
							show: true,
							
							extra: {
								title: '批量审核',
								ids: ids,
								type:'total',
							}
						}
					})
				}
			}
		},
		components: {
			audit
		}
	}
</script>
